export default __webpack_public_path__ + "static/media/arrow.0213784a.svg";